module.exports = __webpack_public_path__ + "static/media/mask-stroke.0f7ca9b1.svg";